export interface IOPayload {
    error?: boolean;
    id?: string | number;
}

export type DataPayload = Record<string, unknown>;

export enum NotificationEventEnum {
    CONNIE_GEOJSON = 'connie-geojson',
    CONNIE_STATISTIC_TO_VALIDATE = 'connie-statistic-to-validate',
    DATA_EXPORT = 'data/export',
    DEPOSIT_EXPORT = 'deposit/export',
    DEPOSIT_VALIDATION = 'deposit/validation',
    FIELD_INTERVENTION_EXPORT = 'field-intervention/export',
    MAP_FILTER_DELETED = 'map-filter/deleted',
}
